const url = {

  translations: {
    'temperatura': 'temperature',
    'chuva': 'rain',
    'vento': 'wind',
    'umidade': 'humidity',
  },
  
  getUrlHash: () => {
    const splitHash = location.hash.split('#')

    return location.hash ? url.translations[splitHash[1]] : null
  },

}

export default url